import React from 'react';
import { withTranslation } from 'react-i18next';
// date drop down list
class DropdownMeetingDate extends React.Component {
  constructor(props) {
    super(props);
    this.changeWbMeetingDropdown = this.changeWbMeetingDropdown.bind(this);
  }

  changeWbMeetingDropdown(e, meetingDate) {
    const mid = meetingDate.id;
    const { actions } = this.props;
    if (typeof mid !== 'undefined') {
      showLoaderWidget($('#content'));
      $.get(`${wbConfig.baseUrl}/meeting/meetingDetails`, { id: mid, json: true }, (resp) => {
        removeLoader();
        const _meeting = resp.data.meeting || {};
        highlightLeftMenuNav('meeting', mid, 'meeting', _meeting);
        actions.MeetingChangePage(resp.data);
      });
      if (typeof history.pushState !== 'undefined') {
        let url = `${wbConfig.baseUrl}/meeting/meetingDetails?id=${mid}`;
        if (typeof getAppContext !== 'undefined' && getAppContext() == 'msteams') {
          url = `${url}&from_where=msteams`;
        }
        window.history.pushState({
          urlPath: url, state: stateCount, rand: Math.random(), menuId: 'menu-wb-mymeeting',
        }, '', url);
        stateCount++;
      }
    }
    return false;
  }

  render() {
    const { t } = this.props;
    const { meeting } = this.props;
    const { dateDropdown } = this.props;
    const enableDropdown = dateDropdown != '';

    let displayDate = dateDropdown[0];
    if (typeof displayDate !== 'undefined' && meeting.id != displayDate.id) {
      for (const d in dateDropdown) {
        if (dateDropdown[d].id == meeting.id) {
          displayDate = dateDropdown[d];
        }
      }
    }
    let date1 = typeof displayDate !== 'undefined' ? displayDate.name : '';

    if (typeof displayDate !== 'undefined' && displayDate.name != 'No Date') {
      const dateStr = date1.split('at');
      date1 = date1;
    }
    const { paddLeft } = this.props;
    const { paddRightSide } = this.props;
    return (
      <div className="meetingDateDD floatLeft" style={{ paddingLeft: paddLeft, paddingRight: paddRightSide, minWidth: '140px', maxWidth: '160px' }}>
        <div className="labels" style={{ fontWeight: 'bold' }}>{t("View meeting for")}</div>
        <div className="meeting-drowndown-dates">
          <div className="div-dropdown-wrapper" style={{ position: 'relative' }}>
            <div className="div-dropdown">
              <div className="div-dropdown-text truncateText" data-id={typeof displayDate !== 'undefined' ? displayDate.id : ''} style={{ paddingLeft: '0px' }}>
                <div className="wbdropdown-mdate">{date1}</div>
              </div>
            </div>
            <div className="div-dropdown-options" style={{ position: 'absolute', width: '100%', overflowY: 'auto' }}>
              {
                enableDropdown
                && dateDropdown.map((date, index) => (
                  <div className="div-dropdown-option" data-id={date.id} key={date.id}>
                    <div className="div-dropdown-option-text" data-id={date.id} onClick={e => this.changeWbMeetingDropdown(e, date)}>{date.name}</div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(DropdownMeetingDate);
